import React, { useEffect, useState, useContext, useMemo } from "react";
import { Typography, Box, Backdrop, CircularProgress, InputAdornment, TextField, Button, Stack, TableCell, DialogContent, IconButton, Dialog, MenuItem} from "@mui/material";
import { Search, InfoOutlined, InsertDriveFileOutlined } from '@mui/icons-material';
import Header from "../layout/Header";
import SorTable from "../ui/sortable";
import { API } from "../../conf";
import { Context } from "../../App"; import theme from '../../theme';
import moment from 'moment';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Graph from "../ui/graph";
pdfMake.vfs = pdfFonts.pdfMake?.vfs || pdfFonts.vfs;

export default function GrandLivre() {
    const { updateConnect } = useContext(Context)
    const [organisation, setOrganisation] = useState(JSON.parse(sessionStorage.getItem('eglise')))
    const [agent, setAgent] = useState(JSON.parse(sessionStorage.getItem('user')))
    const [eglises, setEglises] = useState([])
    const [egliseId, setEgliseId] = useState('')
    const editCol = {header: "", sortable: false, row: (row, index)=><TableCell key={index} sx={{minWidth:'80px', maxWidth:'120px'}} >
        <IconButton aria-label="informations complémentaires" onClick={()=>{setObj(row); manage_dialog(true, 'info')}}><InfoOutlined fontSize="small"/></IconButton>
        {row.is_depense&&<IconButton aria-label="Edit facture" disabled={row.facture?.length<=0} onClick={()=>{setObj(row); manage_dialog(true, 'facture')}}><InsertDriveFileOutlined fontSize="small"/></IconButton>}
    </TableCell>}
    const table = [
        {header: "Date", sortable: true, sortBy:(el)=>new Date(el.date).getTime(), row: (row, index)=><TableCell key={index} align="center" >{moment.utc(row.date).format('DD/MM/YYYY')}</TableCell>},
        {header: "Libellé", sortable: true, sortBy:el=>el.libelle.toLowerCase(), row: (row, index)=><TableCell key={index} sx={{minWidth:'150px', width:'100%'}} align="center">{row.libelle}</TableCell>},
        {header: "Montant", sortable: true, sortBy:el=>el.montant*(el.is_depense?-1:1), row: (row, index)=><TableCell key={index} align="right" style={{fontWeight:'bold', color: row.is_depense? theme.palette.carmine.main : theme.palette.valide.main}}>{(row.is_depense?'-':'+')+row.montant.toFixed(2)}€</TableCell>},
    ]
    const [loading, setLoad] = useState(false)
    const [start_date, setStart] = useState(moment().subtract(1,'month').format('yyyy-MM-DD'))
    const [end_date, setEnd] = useState(moment().format('yyyy-MM-DD'))
    const [search_input, setSearch] = useState('')
    const [journal, setJournal] = useState()
    const [pdf, setPdf] = useState()
    const [img, setImg] = useState()
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('')
    const [obj, setObj] = useState()
    const [comptes, setComptes] = useState([])

    const eglise = useMemo(()=>organisation&&organisation.type==='église' ? organisation : eglises.find(el=>el._id===egliseId), [egliseId, eglises, organisation])

    function create_facture(index) { return new Promise((resolve, reject) => {
        fetch(API.concat(`/depenses/download/${obj._id}/${index}`), {
            method:'GET',
            headers: {
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const blob = await response.blob()
                    resolve(URL.createObjectURL(blob))
                }else resolve('')
            }
        })
    })}

    function get_facture(index) {
        setLoad(true)
        const filepath = obj.facture[index]
        create_facture(index).then(url=>{
            if (filepath.slice(filepath.lastIndexOf('.'))==='.pdf') {
                setPdf(url); setImg()
            }else {
                setImg(url); setPdf()
            }
            setLoad(false)
        })
    }

    function manage_dialog(status, action) {
        setOpen(status)
        setAction(action)
        if (!status) {
            setObj()
            setPdf()
        }
    }

    function get_lineargraph_data() {
        const normalized_dates = [...new Set(journal.map(dep=>moment.utc(dep.date).format('yyyy-MM-DD')))]
        const dates = normalized_dates.map(dt=> new Date(dt))
        let data = [{label:'Recette', values: normalized_dates.map(date => journal.filter(el=> moment.utc(el.date).format('yyyy-MM-DD')===date&&!el.is_depense).reduce((tt,cdep)=>tt+cdep.montant, 0))}, {label:'Dépense', values: normalized_dates.map(date => journal.filter(el=> moment.utc(el.date).format('yyyy-MM-DD')===date&&el.is_depense).reduce((tt,cdep)=>tt+cdep.montant, 0))}]
        return {dates, data}
    }

    function get_journal() {
        if(eglise?.number){
            setLoad(true)
            fetch(API.concat(`/eglises/${eglise.number}/flux/${JSON.stringify([new Date(moment.utc(end_date).add(1, 'day')), new Date(start_date)])}`), {
                method:'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async res=>{
                const token = res.headers.get('x-auth-token')
                if(res.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', res.headers.get('x-auth-token'))
                    }
                    if (res.status === 200) {
                        const json = await res.json()
                        const recettes = json.dons.map(dbd=>{
                            dbd.date = dbd._id
                            dbd.montant = dbd.dons.reduce((tt, don)=>tt+Math.round((don.offrande_globale*0.6+Number.EPSILON)*100)/100+don.offrande_spe_eglise.reduce((tto, off)=>tto+off.montant,0),0)
                            dbd.libelle = 'recette'
                            return dbd
                        })
                        const depenses = json.depenses.map(dep=>{dep.is_depense=true; return dep})
                        const sorted = recettes.concat(depenses).sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
                        setJournal(sorted)
                        setLoad(false)
                    }else setLoad(false)
                }
            })
        }
    }

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-,.€]/gi,'').toLowerCase()
    }

    function get_searchable(row) {
        return row.libelle+' '+row.montant.toFixed(2)
    }

    useEffect(()=>{
        if(eglise?.number) {
            const query = new URLSearchParams({eglise: eglise.number}).toString()
            fetch(API.concat(`/comptes/by?${query}`), {
                method:'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        setComptes(json)
                        get_journal()
                    } 
                }
            })
        }
    }, [eglise])

    useEffect(()=>{
        if (organisation&&organisation.type==='fédération') {
            setLoad(true)
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length>0 ? {number:{$in: agent.eglises}}:{type:'église'})}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json();
                        setEglises(json)
                        setLoad(false)
                    }
                }
            })
        }
    }, [organisation])

    useEffect(()=>{
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
    },[])
     
    
    return(
        <div style={{display:'flex', flexDirection:'column', paddingBottom:'30px'}}>
            <Header/>
            <Typography sx={{textAlign:'center', marginTop:'20px', fontSize:26}}>Grand Livre</Typography>
            {organisation&&organisation.type==='fédération'&&<TextField select size="small" label="église" sx={{alignSelf:'end',marginBottom:3, width:'25%', marginRight:3, minWidth:'200px'}} value={egliseId} onChange={e=>setEgliseId(old=>{if(old!==e.target.value)setJournal([]); return e.target.value})}>
                {eglises.sort((a,b)=>a.nom.toLowerCase()<b.nom.toLowerCase() ? -1 : 1).map(eglise=><MenuItem key={eglise._id} value={eglise._id}>{`${eglise.nom} - ${eglise.commune.toUpperCase()}`}</MenuItem>)}
            </TextField>}
            <Box sx={{paddingX:'20px', marginTop:'30px'}}>
                <Box display='flex' justifyContent='space-between' alignItems='center'>
                    <Stack direction='row' spacing={2} sx={{alignItems:'center'}}>
                        <Typography fontWeight={600} fontSize={16}>Période:</Typography>
                        <TextField
                        size="small"
                        margin="normal"
                        sx={{minWidth:'100px'}}
                        InputLabelProps={{shrink: true}}
                        label="Date de début"
                        type='date'
                        value={start_date}
                        onChange={(event)=> {
                            setStart(event.target.value)
                            if (end_date!=='' && (new Date(end_date).getTime() - new Date(event.target.value).getTime()) <= 0) {
                                setEnd('')
                            } 
                        }}
                        />
                        <TextField
                        size="small"
                        margin="normal"
                        sx={{minWidth:'100px'}}
                        InputLabelProps={{shrink: true}}
                        label="Date de fin"
                        type="date"
                        value={end_date}
                        onChange={(event)=> {
                            setEnd(event.target.value)
                            if (start_date!=='' && (new Date(event.target.value).getTime() - new Date(start_date).getTime()) <= 0) {
                                setStart('')
                            }
                        }}
                        />
                        <Button variant="contained" disabled={start_date===''||end_date===''||!eglise} onClick={get_journal}>Appliquer</Button>
                    </Stack>
                    <Button variant="contained" onClick={()=> {manage_dialog(true, 'graph')}} disabled={!journal?.length>0}>Graph</Button>
                </Box>
                <TextField
                size="small"
                label="Rechercher une dépense ou une entrée par libellé ou montant"
                disabled={!journal?.length>0}
                sx={{width:'60%', minWidth:'300px', marginTop:'10px'}}
                value={search_input}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                        <Search />
                        </InputAdornment>
                    ),
                }}
                onChange={(event)=> setSearch(event.target.value)}
                />
                
                {journal && !loading && <SorTable data={journal.filter(row=> normalize(get_searchable(row)).includes(normalize(search_input)))} table={table.concat([editCol])} rowsPerPage={50} rowsPerPageOptions={[50, 100, 300]}/>}
            </Box>

            <Backdrop open={loading}><CircularProgress color="inherit" /></Backdrop>
            <Dialog open={open} onClose={()=>manage_dialog(false, '')} maxWidth={action=== 'info'? 'xs':'md'} fullWidth>
                <DialogContent>
                {action==='facture' &&obj&&<Box display='flex' flexDirection='column' margin='20px 10px'> 
                    <Typography variant="h5" align="center" marginBottom='20px'>Facture</Typography>
                    <TextField select sx={{minWidth:'300px', width:'60%', alignSelf:'center', marginBottom:'20px'}} label='Fichier' onChange={e=>{get_facture(e.target.value)}}>
                        {obj.facture?.map((file, index)=><MenuItem key={index} value={index}>{file.slice(file.lastIndexOf(`\\`)+1)}</MenuItem>)}
                    </TextField>
                    {img && <img src={img} style={{width:'100%', height:'600px'}} loading="lazy" alt="facture" />}
                </Box>}
                    {pdf && <embed src={pdf} width='100%' height='600px' type="application/pdf" />}
                    {action==='info'&& obj && (obj.is_depense ? <Box margin='20px 10px'>
                        <Typography>Date: { moment.utc(obj.date).format('DD/MM/YYYY')}</Typography>
                        <Typography textTransform={'capitalize'}>Libellé: {obj.libelle}</Typography>
                        <Typography>Compte débité: {comptes.find(cpt=>cpt.num===obj.compte)?.num_compte} {comptes.find(cpt=>cpt.num===obj.compte).libelle}</Typography>
                        <Typography>Montant de la dépense: {obj.montant.toFixed(2)}€</Typography>
                        <Typography>Mode de paiement:</Typography>
                        {obj.paymode?.especes>0 && <Typography>Espèces: {obj.paymode?.especes.toFixed(2)}€</Typography>}
                        {obj.paymode?.cheques.filter(cheque => cheque.montant>0).length>0 && <Stack sx={{marginLeft: '30px'}}>
                            <Typography>Chèques:</Typography>
                            {obj.paymode?.cheques.filter(cheque => cheque.montant>0).map((cheque, index)=>
                                <Typography key={index} sx={{marginLeft: '20px'}}>chèque {cheque.banque} n°{cheque.num_cheque !== '' ? cheque.num_cheque : '_______'} de {cheque.montant.toFixed(2)}€</Typography>)}
                        </Stack>}
                        {obj.paymode?.virement?.montant>0 && <Typography sx={{marginLeft: '30px'}}>Virment du {obj.paymode?.virement.date!== '' ? moment.utc(obj.paymode?.virement.date).format('DD/MM/YYYY') : '_______'} référencé 
                        {obj.paymode?.virement.ref !== '' ? ` ${obj.paymode?.virement.ref}` : ' _______'} de {obj.paymode?.virement.montant.toFixed(2)}€</Typography>}
                        {obj.facture.filter(file => file!=='').length>0&&<Typography sx={{marginTop:'10px'}}>Facture:</Typography> }
                            {obj.facture.filter(file => file!=='').map((file, index)=>(
                                <Typography key={index} fontSize={14} sx={{marginLeft:'15px'}}>{file.slice(file.lastIndexOf(`\\`)+1)}</Typography>))}  
                    </Box>:
                    <Box margin='20px 10px'>
                        <Typography>Date des dons: { moment.utc(obj?.date).format('DD/MM/YYYY')}</Typography>
                        <Typography >Nombre de dons: {obj.dons.length}</Typography>
                        <Typography>Total dîme: {obj.dons.reduce((tt,don)=>tt+don.dime,0).toFixed(2)}€</Typography>                        
                        <Typography>Total offrande globale: {obj.dons.reduce((tt,don)=>tt+don.offrande_globale,0).toFixed(2)}€</Typography>                        
                        <Typography>Total offrande spécifiée locale: {obj.dons.reduce((tt,don)=>tt+don.offrande_spe_eglise.reduce((tto, off)=>tto+off.montant,0),0).toFixed(2)}€</Typography>                        
                        <Typography>Total offrande spécifiée fédérale: {obj.dons.reduce((tt,don)=>tt+don.offrande_spe_feam.reduce((tto, off)=>tto+off.montant,0),0).toFixed(2)}€</Typography>                        
                        <Typography>Total: {obj.dons.reduce((tt,don)=>tt+don.dime+don.offrande_globale+don.offrande_spe_feam.concat(don.offrande_spe_eglise).reduce((tto, off)=>tto+off.montant,0),0).toFixed(2)}€</Typography>                        
                    </Box>)}
                    {action==='graph' && <Graph data={[{label:'Recette', value: journal.filter(el=>!el.is_depense).reduce((tt, current)=>tt+current.montant,0)},{label:'Dépense', value: journal.filter(el=>el.is_depense).reduce((tt, current)=>tt+current.montant,0)}]}
                    line_data = {get_lineargraph_data()}/>}
                </DialogContent>
            </Dialog>
        </div>
    )
}